import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-subtitle-1 font-weight-bold ma-1 secondary--text" }
const _hoisted_3 = { class: "text-subtitle-2" }
const _hoisted_4 = { class: "text-subtitle-1 font-weight-bold ma-1 secondary--text" }
const _hoisted_5 = { class: "text-subtitle-2" }
const _hoisted_6 = { class: "text-subtitle-1 font-weight-bold ma-1 secondary--text" }
const _hoisted_7 = { class: "text-subtitle-2" }
const _hoisted_8 = { class: "ilos-tree-wrapper" }
const _hoisted_9 = {
  key: 0,
  class: "word-break-all"
}
const _hoisted_10 = { class: "d-inline-block ltr" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "d-flex justify-end mt-5" }
const _hoisted_13 = { class: "font-weight-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectedCourse = _resolveComponent("SelectedCourse")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_treeview = _resolveComponent("v-treeview")!
  const _component_Ilos = _resolveComponent("Ilos")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_DialogComponent = _resolveComponent("DialogComponent")!

  return (_openBlock(), _createBlock(_component_v_card, {
    style: _normalizeStyle(_ctx.listView ? 'box-shadow: none;' : '')
  }, {
    default: _withCtx(() => [
      (!_ctx.listView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_SelectedCourse, {
              appId: _ctx.appId,
              routeName: _ctx.changeScopeRouteName
            }, null, 8, ["appId", "routeName"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          (!_ctx.listView)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 0,
                flat: "",
                class: "d-flex",
                width: "100%"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("Subjects")), 1),
                  _createVNode(_component_v_spacer),
                  (_ctx.haveAddPermisions)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        class: "success",
                        onClick: _ctx.openAddSubject
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("buttons.add")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_card, {
            flat: "",
            class: "d-flex px-5 py-5",
            width: "100%"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer, { class: "d-lg-block d-none" }),
                  _createVNode(_component_v_col, { lg: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.search,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                        modelModifiers: { trim: true },
                        "append-icon": "mdi-magnify",
                        label: `${_ctx.$t('Search_by')} ${_ctx.$t('Title')}`,
                        "single-line": "",
                        "hide-details": ""
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (!_ctx.error)
        ? (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { class: "justify-center" }, {
                default: _withCtx(() => [
                  (_ctx.loading)
                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                        key: 0,
                        indeterminate: "",
                        color: "secondary",
                        value: 20
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_ctx.filteredSubjects.length)
                ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                    key: 0,
                    popout: "",
                    focusable: "",
                    modelValue: _ctx.currentPanel,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPanel) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSubjects, (subject, i) => {
                        return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                          class: "my-1",
                          key: subject.id,
                          onClick: ($event: any) => (_ctx.listView ? '' : _ctx.openPanel(i, subject.id))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_expansion_panel_title, {
                              id: `subject-${subject.id}`,
                              class: "text-subtitle-2",
                              "disable-icon-rotate": ""
                            }, {
                              actions: _withCtx(() => [
                                (subject.active)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      color: "success",
                                      title: _ctx.$t('labels.active')
                                    }, {
                                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                        _createTextVNode("check", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["title"]))
                                  : (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 1,
                                      color: "grey",
                                      title: _ctx.$t('labels.inactive')
                                    }, {
                                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                        _createTextVNode("mdi-alert-circle", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["title"]))
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(subject.id) + " ) " + _toDisplayString(subject.name) + " ", 1)
                              ]),
                              _: 2
                            }, 1032, ["id"]),
                            _createVNode(_component_v_expansion_panel_text, null, {
                              default: _withCtx(() => [
                                (!_ctx.listView)
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 0,
                                      "no-gutters": "",
                                      class: "flex-sm-row flex-column"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("Title")) + " :", 1),
                                            _createElementVNode("span", _hoisted_3, _toDisplayString(subject.name), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, null, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("Active")) + " :", 1),
                                            _createElementVNode("span", _hoisted_5, _toDisplayString(subject.active ? _ctx.$t("Yes") : _ctx.$t("No")), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, null, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("lectureCount")) + " :", 1),
                                            _createElementVNode("span", _hoisted_7, _toDisplayString(subject.lectureCount), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_8, [
                                  _createElementVNode("h3", null, _toDisplayString(_ctx.$t("ILOS")), 1),
                                  (_ctx.isFlexibleILOs)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _createVNode(_component_v_treeview, {
                                          items: _ctx.removeEmptyChildren(subject.ilos as TreeView[]),
                                          class: "wrappable-tree",
                                          "item-title": "name",
                                          "item-value": "id",
                                          "open-all": ""
                                        }, {
                                          prepend: _withCtx(({ item }) => [
                                            _createElementVNode("span", _hoisted_10, _toDisplayString(item.ilo_code), 1),
                                            _cache[7] || (_cache[7] = _createTextVNode(" ) ", -1))
                                          ]),
                                          _: 1
                                        }, 8, ["items"])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createVNode(_component_Ilos, {
                                          ilos: subject.ilos as HeaderILos
                                        }, null, 8, ["ilos"])
                                      ]))
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                  (_ctx.haveEditPermisions && subject.id)
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 0,
                                        small: "",
                                        class: "mx-2",
                                        color: "primary",
                                        onClick: ($event: any) => (_ctx.openEditPage(subject.id))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("btn_edit")), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.haveDeletePermisions && subject.id)
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 1,
                                        small: "",
                                        class: "mx-2",
                                        color: "error",
                                        onClick: ($event: any) => (_ctx.showDeleteConfirm(subject.id))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("buttons.delete")), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : (!_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 1,
                      color: "info",
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("No_subjects")), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_card_text, { key: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_alert, {
                color: "error",
                class: "text-center"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$utils.servertranslate(_ctx.error)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
      (!_ctx.listView)
        ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 3 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                class: "blue-grey white--text",
                onClick: _ctx.goCoursesList
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("buttons.back")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_DialogComponent, {
        modelValue: _ctx.showDeleteDialog,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showDeleteDialog) = $event))
      }, {
        header: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("titles.confirmMessage")), 1)
        ]),
        body: _withCtx(() => [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("messages.sureDelete")), 1)
        ]),
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            class: "primary mx-1 white--text",
            loading: _ctx.loadingDelete,
            disabled: _ctx.loadingDelete,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteSubject()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("buttons.confirm")), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled"]),
          _createVNode(_component_v_btn, {
            class: "secondary white--text",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDeleteDialog = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("buttons.cancel")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["style"]))
}